import React, { useState, useEffect } from 'react'

const adminItems = [
	{ key: 'dashboard', label: 'Dashboard', icon: (
		<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
			<path d="M3 13h8V3H3v10zM13 21h8v-8h-8v8z"/>
			<path d="M13 3h8v6h-8zM3 17h8v4H3z"/>
		</svg>
	) },
	{ key: 'maps', label: 'Lot Status', icon: (
		<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
			<path d="M3 6l6-3 6 3 6-3v15l-6 3-6-3-6 3V6z"/>
			<path d="M9 3v15M15 6v15"/>
		</svg>
	) },
	{ key: 'plan-share', label: 'Live Plan', icon: (
		<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
			<path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"/>
			<polyline points="16,6 12,2 8,6"/>
			<line x1="12" y1="2" x2="12" y2="15"/>
		</svg>
	) },
	{ key: 'enquiries', label: 'Enquiries', icon: (
		<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
			<path d="M21 15a4 4 0 0 1-4 4H7l-4 4V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4z"/>
		</svg>
	) },
	{ key: 'settings', label: 'Settings', icon: (
		<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
			<circle cx="12" cy="12" r="3"/>
			<path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09a1.65 1.65 0 0 0-1-1.51 1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09a1.65 1.65 0 0 0 1.51-1 1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9c0 .67.39 1.27 1 1.51H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
		</svg>
	) }
]

const superAdminItems = [
	{ key: 'dashboard', label: 'Dashboard', icon: (
		<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
			<path d="M3 13h8V3H3v10zM13 21h8v-8h-8v8z"/>
			<path d="M13 3h8v6h-8zM3 17h8v4H3z"/>
		</svg>
	) },
	{ key: 'plans', label: 'Plans', icon: (
		<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
			<rect x="3" y="3" width="7" height="7"/>
			<rect x="14" y="3" width="7" height="7"/>
			<rect x="3" y="14" width="7" height="7"/>
			<rect x="14" y="14" width="7" height="7"/>
		</svg>
	) },
	{ key: 'tenants', label: 'Tenants', icon: (
		<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
			<path d="M3 7v10a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2H5a2 2 0 0 0-2-2z"/>
			<path d="M8 21v-4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4"/>
		</svg>
	) },
	{ key: 'users', label: 'Users', icon: (
		<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
			<path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/>
			<circle cx="9" cy="7" r="4"/>
			<path d="M22 21v-2a4 4 0 0 0-3-3.87"/>
			<path d="M16 3.13a4 4 0 0 1 0 7.75"/>
		</svg>
	) },
	{ key: 'crm', label: 'CRM Config', icon: (
		<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
			<path d="M21 15a4 4 0 0 1-4 4H7l-4 4V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4z"/>
			<path d="M8 9h8"/>
			<path d="M8 13h6"/>
		</svg>
	) },
	{ key: 'settings', label: 'Settings', icon: (
		<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
			<circle cx="12" cy="12" r="3"/>
			<path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09a1.65 1.65 0 0 0-1-1.51 1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09a1.65 1.65 0 0 0 1.51-1 1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9c0 .67.39 1.27 1 1.51H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
		</svg>
	) }
]

export default function Sidebar({ active = 'maps', onSelect, bare = false, variant = 'admin', logoUrl }) {
	const [collapsed, setCollapsed] = useState(false)
	const items = variant === 'superadmin' ? superAdminItems : adminItems

	useEffect(() => {
		if (typeof document !== 'undefined') {
			document.body.classList.toggle('sidebar-collapsed', collapsed)
		}
	}, [collapsed])
	const buttons = items.map((it) => (
		<button key={it.key} onClick={() => onSelect && onSelect(it.key)} className={`nav-item ${active === it.key ? 'active' : ''}`}>
			<span className="nav-icon">{it.icon}</span>
			<span className="nav-label">{it.label}</span>
		</button>
	))

    if (bare) {
        return (
            <div className={`nav-vertical ${collapsed ? 'nav-collapsed' : ''}`} style={{ display: 'flex', flexDirection: 'column' }}>
                <div className="nav-list bare">
                    {buttons}
                </div>
                {/* <div className="row-between" style={{ marginTop: 'auto', paddingTop: 16, paddingBottom: 8, justifyContent: 'center' }}>
                    <button aria-label={collapsed ? 'Show menu' : 'Hide menu'} className="sidebar-toggle btn btn-ghost btn-sm" onClick={() => setCollapsed(!collapsed)}>
                        {collapsed ? (
                            <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                                <polyline points="9 18 15 12 9 6"/>
                            </svg>
                        ) : (
                            <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                                <polyline points="15 18 9 12 15 6"/>
                            </svg>
                        )}
                    </button>
                </div> */}
            </div>
        )
    }

    return (
        <div className={`glass nav-card nav-vertical ${collapsed ? 'nav-collapsed' : ''}`} style={{ display: 'flex', flexDirection: 'column' }}>
            <div className="nav-list" style={{ alignItems: 'center' }}>
                {buttons}
            </div>
            <div className="row-between" style={{ marginTop: 'auto', paddingTop: 16, paddingBottom: 8, justifyContent: 'center' }}>
                <button aria-label={collapsed ? 'Show menu' : 'Hide menu'} className="sidebar-toggle btn btn-ghost btn-sm" onClick={() => setCollapsed(!collapsed)}>
                    {collapsed ? (
                        <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                            <polyline points="9 18 15 12 9 6"/>
                        </svg>
                    ) : (
                        <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                            <polyline points="15 18 9 12 15 6"/>
                        </svg>
                    )}
                </button>
            </div>
        </div>
    )
}
